export default "__VITE_ASSET__C7Qc5apY__"